/** TODO: add cam position as uniform gl_PointSize = size * (camPosition.z / -mvPosition.z); */
import * as THREE from 'three';

import partTexture from '../../assets/img/textures/spark.png';

export default class Particles {
    constructor(scene, color, particleNum) {
        this.scene = scene;
        this.color = color;
        this.particleNum = particleNum;

        this.createParticles();
    };

    setupMaterial() {
        let texLoader = new THREE.TextureLoader();
        let particleMap = texLoader.load(partTexture);
        let uniforms = {
            uTexture0: { value: particleMap }
        };

        let material = new THREE.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: `
                attribute float size;
                varying vec3 vColor;
            
                void main()
                {
                    vColor = color;
                    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
		            gl_PointSize = size * (60. / -mvPosition.z); //50. = camera position.z
                    gl_Position = projectionMatrix * mvPosition;
                }
            `,
            fragmentShader: `
                precision mediump float;

                varying vec3 vColor;
                uniform sampler2D uTexture0;
                
                void main()
                {
                    gl_FragColor = vec4(vColor, 1.0);
		            gl_FragColor = gl_FragColor * texture2D(uTexture0, gl_PointCoord);
                }
            `,
            blending: THREE.AdditiveBlending,
            depthTest: false,
            transparent: true,
            vertexColors: true
        });
        return material;
    };

    createParticles() {
        let radius = 20;
        let buffGeo = new THREE.BufferGeometry();
        let positions = [];
        let colors = [];
        let sizes = [];

        let color = new THREE.Color();
        for (let i = 0; i < this.particleNum; i++) {
            positions.push((Math.random() * 2 - 1) * radius);
            positions.push((Math.random() * 2 - 1) * radius);
            positions.push((Math.random() * 2 - 1) * radius);

            color.setHSL(i / this.particleNum, 1.0, 0.5);
            //color.set(this.color);
            colors.push(color.r, color.g, color.b);
            sizes.push(40);
        }

        buffGeo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        buffGeo.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
        buffGeo.setAttribute('size', new THREE.Float32BufferAttribute(sizes, 1).setUsage(THREE.DynamicDrawUsage));

        let material = this.setupMaterial();
        let particles = new THREE.Points(buffGeo, material);
        particles.position.set(0, 30, 0);
        this.scene.add(particles);

        this.particles = particles;
        this.buffGeo = buffGeo;
    };

    update(time) {
        this.particles.rotation.z = 0.01 * time;
        this.particles.position.y -= 0.01;
        if (this.particles.position.y < -30) this.particles.position.y = 30;
        let sizes = this.buffGeo.attributes.size.array;
        for (let i = 0; i < this.particles; i++) {
            console.log(this.particles);
            sizes[i] = 10 * (1 + Math.sin(0.1 * i + time));
        }
        this.buffGeo.attributes.size.needsUpdate = true;
    };
}



